/**
 * @description 日期輸入欄位元件，支援日期、時間和日期時間格式
 * @class JkdatefieldComponent
 * @extends {JkBaseComponent}
 * @implements {OnInit}
 */
import { Component, Input, OnInit, output, input, ChangeDetectionStrategy } from '@angular/core';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { CommonModule, DatePipe } from '@angular/common';
import { JkfieldlabelComponent } from '../jkfieldlabel/jkfieldlabel.component';
import { MaterialModule } from '../../material.module';
import { FormsModule } from '@angular/forms';
import { jkLib } from '../../services/jkCommon';

@Component({
    selector: 'app-jkdatefield',
    templateUrl: './jkdatefield.component.html',
    styleUrls: ['./jkdatefield.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        CommonModule,
        JkfieldlabelComponent,
        MaterialModule,
        DatePipe,
        //DxDateBoxModule,
    ],

})
export class JkdatefieldComponent extends JkBaseComponent  implements OnInit {
  override comType: string = 'jkdatefield';
  override flexStyle:any = { display: 'flex'};
  readonly type = input<string>('date'); // datetime, time
  //@Input()  width: number = 150;
  readonly item = input<string>('');
  readonly showCloseButton = input<boolean>(true);
  readonly dateChange = output<Date | undefined>();
  _date: Date | undefined =  undefined;// string | number | Date
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  get date():Date | undefined {
    return this._date; //(this._date as any);
  }
  set date(d:Date | undefined){
    //alert('set date d: ' + d);
    this._date = d;
    let v = jkLib.date2DateField(d);
    if(this.value !== v){ // 避免無限迴圈
      //alert('set date: ' + v);
      this.value = v;
    }

  };
  _value: string = '';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set value(v:string){
    this._value = v;
    if(v==='' || v===null){
      this.date = undefined as any;
    }else{
      let d = jkLib.dateField2Date(v);
      if(this.date !== d){ // 避免無限迴圈
        this.date = d;
      }
    }
  };
  get value(): string{
    // this._value = jkLib.date2DateField(this.date); FIXME:
    let d = this._date;
    return this._value;
  }
  readonly valueChange = output<string>();
  onValueChanged(e:any) {
    //console.log(e.previousValue);
    //console.log(e.value);
    let newValue = jkLib.date2DateField(e);
    this.valueChange.emit(newValue);
    this.dateChange.emit(e);
  }
  readonly buttonText = input<string>('...');
  readonly onButtonClick = output<any>();


  constructor() {
    super();
    this.width.set(150);
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  addWhere(where: string,fieldName:string,condition:string = '='): string {
    if(this.required() && (this.value === '')){
      let msg = this.label()+' 不可空白.';
      alert(msg);
      throw new Error(msg);

    }
  if(this.value){
    //where += ' AND ('+fieldName + ' = ' + jkLib.quotedStr(this.value)+') ';
    where = jkLib.text2Where(this.value, where, fieldName, condition);

  }
  return where;
}

}


